import { render, staticRenderFns } from "./Curso.vue?vue&type=template&id=d1ebcac6&scoped=true&lang=pug&"
import script from "./Curso.vue?vue&type=script&lang=js&"
export * from "./Curso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ebcac6",
  null
  
)

export default component.exports